// this is the entry point for the client app bundle
import './utils/polyfills';
import React from 'react';
import { hydrate } from 'react-dom';
import { Router } from 'react-router-dom';
import { injectGlobal, ThemeProvider } from 'styled-components';
import { renderRoutes } from 'react-router-config';
import { AsyncComponentProvider } from 'react-async-component';
import asyncBootstrapper from 'react-async-bootstrapper';
import { Provider } from 'react-redux';
import branch from 'branch-sdk';
import { currentTheme } from './theme';
import routes, { maintenanceRoutes } from './routes';
import createStore from './redux/store';
import history from './history';
import normalize from './theme/normalize';
import { client as intercomMiddleware } from './redux/middleware/intercom';
import uetMiddleware from './redux/middleware/uet';
import {
  getIsAuthenticated,
  getAuthUserId,
} from './redux/modules/root-reducer';
import { getUIAction } from './utils/ui';

injectGlobal([], normalize);

const initData = window.__INIT_DATA_FROM_SERVER_RENDER__; // eslint-disable-line
const rehydrateState = window.ASYNC_COMPONENTS_STATE; // eslint-disable-line
const uetEvents = window.uetq || [];
const MAINTENANCE_DATA = window.MAINTENANCE_DATA || {};
const store = createStore(initData, history, [
  intercomMiddleware(window),
  uetMiddleware(window, uetEvents),
]);

const app = (
  <AsyncComponentProvider rehydrateState={rehydrateState}>
    <ThemeProvider theme={currentTheme}>
      <Provider store={store}>
        <Router history={history}>{renderRoutes(MAINTENANCE_DATA?.isActive ? maintenanceRoutes : routes)}</Router>
      </Provider>
    </ThemeProvider>
  </AsyncComponentProvider>
);

const renderApp = () => {
  hydrate(app, document.getElementById('app'));
};

asyncBootstrapper(app).then(() => {
  renderApp();
});

if (module.hot) {
  module.hot.accept(renderApp);
}

const setGoogleTagManagerData = userId => {
  const branchSessionItem = sessionStorage.getItem('branch_session');
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  const branchSession = JSON.parse(branchSessionItem);
  window.dataLayer.push({
    event: 'Branch IDs set',
    branchsessionid: branchSession.session_id,
    branchidentityid: branchSession.identity_id,
    user: {
      loggedIn: !!userId,
      id: userId,
    },
  });
};

const setupUI = () => {
  const action = getUIAction(navigator.userAgent || '');
  store.dispatch(action);
}

const setupBranch = () => {
  // This code is executed only on the client
  // where branch can track the source URL.
  branch.init(process.env.BRANCH_KEY, err => {
    if (err) {
      return setTimeout(setupBranch, 1000); // try again in 1s.
    }
    const userId = getAuthUserId(initData);
    setGoogleTagManagerData(userId);
    setupUI();
    if (getIsAuthenticated(initData)) {
      branch.setIdentity(userId);
    } else {
      branch.logout();
    }
    return null;
  });
};
setupBranch();

const wardlesQueryString = window.location.search;                       //   Redirect to wardles health care supplies login page
if (wardlesQueryString === '?_wardles=true') {
  window.location.href = "https://healthcaresupplies.well.co.uk/login";
}